import { render, staticRenderFns } from "./ImportProductModal.vue?vue&type=template&id=9257a526"
import script from "./ImportProductModal.vue?vue&type=script&lang=js"
export * from "./ImportProductModal.vue?vue&type=script&lang=js"
import style0 from "./ImportProductModal.vue?vue&type=style&index=0&id=9257a526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports